// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Main Container */
.arabic-main-container {
  background-color: #e5e5e5;
  margin: 0;
  padding: 0;
  height: 100%;
}

/* Heading */
.arabic-heading {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-family: "Roboto", sans-serif;
  font-weight: 700;
  font-size: 5.5rem;
  font-style: normal;
  line-height: 100%;
  margin-top: 50px;
}

.arabic-sub-heading-1 {
  color: rgb(18, 57, 77);
  font-family: "Roboto Bold", sans-serif;
}

.arabic-sub-heading-2 {
  font-family: "Roboto-Slab";
  color: rgb(66, 126, 147);
  font-weight: 200;
}

/* Sub Heading - Explore */
.sub-heading-font {
  color: #333;
  font-family: "Roboto Bold", sans-serif;
  /* font-size: 50%; */
}

/* Sub Heading - Arab American History */
.sub-heading-font2 {
  font-family: "Roboto-Slab", sans-serif;
  color: #427e93;
  font-weight: 200;
}

/* Search Div */
.search-div {
  display: flex;
  justify-content: center;
  text-align: center;
  margin-top: 60px;
}

/* Search Input */
.search-input {
  text-indent: 10%;
  font-size: 22px;
  height: 68px;
  width: 720px;
  border-top: 0px;
  border-right: 0px;
  border-left: 0px;
  border-bottom: 2px solid #cccccc;
  border-radius: 36px;
  font-family: "Roboto", sans-serif;
}

/* Or Image Div */
.arabic-or-image-div {
  height: 24px;
  width: 22px;
  font-family: "Roboto Slab", sans-serif;
  font-style: normal;
  font-weight: 400;
  /* font-size: 16px; */
  /* line-height: 150%; */
  text-align: center;
  color: #fff;
  margin-top: 20px;
}

.arabic-or-image-div svg {
  width: 500px;
  /* height: auto; */
}

@media (max-width: 550px) {
  .arabic-or-image-div svg {
    width: 90%;
  }
}

/* Browse Collection Div */
.arabic-browse-collection-div {
  display: flex;
  justify-content: center;
  text-align: center;
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 28px;
  line-height: 100%;
  margin-top: 25px;
  margin-bottom: 20px;
}

/* Browse Text - Browse our collection */
.arabic-browse-text-span {
  color: #333;
  font-family: "Roboto Bold", sans-serif;
}

/* Browse Text - By Selecting */
.arabic-by-selecting-span {
  color: #999;
  margin-top: 5px;
  display: inline-block;
}

/* Newspaper Button */
.arabic-newspaper-button {
  text-indent: 5%;
  height: 48px;
  width: 15rem;
  padding: 5px;
  padding-right: 1.8em;
  background: #fff;
  align-items: center;
  border: 1px solid #cccccc;
  font-family: "Roboto", sans-serif;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  font-style: normal;
  background-color: #fff;
  text-align: right;
}

/* Smaller Search Icon */
.arabic-smaller-search-icon {
  color: #ff0000;
  height: 14px;
  float: left;
  margin-left: 10px;
  margin-top: 2px;
  display: flex;
  align-items: center;
}

/* Collections Div */
.collections-div {
  text-align: center;
  border-left: 2px solid #cccccc;
}

/* Icon Style */
.arabic-icon-style {
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: end;
}

/* Info Style */
.arabic-info-style {
  padding: 8px;
  margin: 0px;
  display: flex;
  align-items: center;
}

/* Span Style - 4382 */
.arabic-span-style-4382 {
  font-family: "Roboto-Slab", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 40px;
  color: #427e93;
}

/* Span Style - Below 4382 */
.arabic-span-style-below-4382 {
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 150%;
  color: #808080;
}

/* Search and Browse Div */
.arabic-search-browse-div {
  display: flex;
  justify-content: center;
  text-align: center;
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 2rem;
  line-height: 150%;
  color: #666666;
}

@media (max-width: 600px) {
  .search-browse-div {
    font-size: 1.5rem;
  }
}

/* Learn More Span */
.arabic-learn-more-span {
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 167%;
  color: #ff0000;
}

/* Drop Down Style */
.drop-down-style {
  height: 48px;
  border: 1px solid #cccccc;
  border-radius: 36px;
  background-color: #ffffff;
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  color: #808080;
  padding-right: 10px;
}

.arabic-stats {
  display: flex;
  justify-content: center;
  align-items: center;
  border-right: solid #cccccc;
  margin: 1%;
}

.arabic-periodicals-books {
  display: flex;
  justify-content: center;
  justify-content: space-evenly;
}

@media (max-width: 700px) {
  .heading {
    font-size: 4.5rem;
  }
}

@media (max-width: 380px) {
  .heading {
    font-size: 3.5rem;
  }
}

@media (max-width: 600px) {
  .arabic-periodicals-books {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .arabic-periodicals {
    margin: 20px;
  }
}

.arabic-main-container {
  background-color: #dedede;
}

.arabic-heading {
  font-family: "Roboto Bold", "Roboto", sans-serif;
  font-size: 4.15rem;
  line-height: 1;
  margin-top: 0;
}

.arabic-heading p {
  margin-bottom: 1rem;
}

.arabic-browse-text-span {
  color: #666666;
  font-family: "Roboto Bold", "Roboto", sans-serif;
  font-size: 28px;
}

.arabic-by-selecting-span {
  color: #999999;
  font-family: "Roboto Bold", "Roboto", sans-serif;
  font-size: 24px;
}

.arabic-periodicals-books {
  gap: 32px;
  justify-content: center;
  margin: 26px auto 34px;
  max-width: 1320px;
  width: calc(100% - 56px);
}

.arabic-periodicals-books .browse-format-card {
  align-items: flex-end;
  min-height: 205px;
  text-align: right;
}

.arabic-periodicals-books .browse-format-card__icon {
  margin-left: 0;
  margin-right: 0;
}

.arabic-periodicals-books .browse-format-card__title,
.arabic-periodicals-books .browse-format-card__subtitle {
  width: 100%;
}

.arabic-periodicals-books .browse-format-card__cta {
  align-self: flex-end;
  flex-direction: row;
}

.arabic-stats {
  border-right: 0;
  margin: 0;
}

.stats-panel[dir="rtl"] .stats {
  border-left: 0;
  border-right: 1px solid #d9d9d9;
}

.stats-panel[dir="rtl"] .stats:first-child {
  border-right: 0;
}

.stats-panel[dir="rtl"] .stats .icon-style {
  padding: 0 0 0 22px;
}

.stats-panel[dir="rtl"] .info-style {
  text-align: right;
}

.arabic-span-style-4382 {
  font-family: "Roboto Bold", "Roboto", sans-serif;
}

.arabic-span-style-below-4382 {
  font-family: "Roboto Bold", "Roboto", sans-serif;
}

.arabic-search-browse-div {
  font-family: "Roboto Bold", "Roboto", sans-serif;
  font-weight: 500;
  margin-left: auto;
  margin-right: auto;
  max-width: 1120px;
  padding: 0;
}

.arabic-learn-more-span {
  font-family: "Roboto Bold", "Roboto", sans-serif;
  font-size: 21px;
}

@media (max-width: 700px) {
  .arabic-heading {
    font-size: 3.6rem;
  }
}

@media (max-width: 600px) {
  .arabic-periodicals-books {
    gap: 18px;
    margin-top: 24px;
    padding: 0 18px;
    width: 100%;
  }
}

@media (max-width: 380px) {
  .arabic-heading {
    font-size: 2.9rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles-arabic/home.rtl.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,yBAAyB;EACzB,SAAS;EACT,UAAU;EACV,YAAY;AACd;;AAEA,YAAY;AACZ;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,iCAAiC;EACjC,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,0BAA0B;EAC1B,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,WAAW;EACX,sCAAsC;EACtC,oBAAoB;AACtB;;AAEA,wCAAwC;AACxC;EACE,sCAAsC;EACtC,cAAc;EACd,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA,iBAAiB;AACjB;EACE,YAAY;EACZ,WAAW;EACX,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,wCAAwC;AACxC;EACE,WAAW;EACX,sCAAsC;AACxC;;AAEA,+BAA+B;AAC/B;EACE,WAAW;EACX,eAAe;EACf,qBAAqB;AACvB;;AAEA,qBAAqB;AACrB;EACE,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA,wBAAwB;AACxB;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA,eAAe;AACf;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,eAAe;AACf;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA,oBAAoB;AACpB;EACE,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gDAAgD;EAChD,kBAAkB;EAClB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gDAAgD;EAChD,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gDAAgD;EAChD,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,sBAAsB;EACtB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,SAAS;AACX;;AAEA;EACE,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;EAChD,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,gDAAgD;EAChD,eAAe;AACjB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,SAAS;IACT,gBAAgB;IAChB,eAAe;IACf,WAAW;EACb;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/* Main Container */\n.arabic-main-container {\n  background-color: #e5e5e5;\n  margin: 0;\n  padding: 0;\n  height: 100%;\n}\n\n/* Heading */\n.arabic-heading {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  font-family: \"Roboto\", sans-serif;\n  font-weight: 700;\n  font-size: 5.5rem;\n  font-style: normal;\n  line-height: 100%;\n  margin-top: 50px;\n}\n\n.arabic-sub-heading-1 {\n  color: rgb(18, 57, 77);\n  font-family: \"Roboto Bold\", sans-serif;\n}\n\n.arabic-sub-heading-2 {\n  font-family: \"Roboto-Slab\";\n  color: rgb(66, 126, 147);\n  font-weight: 200;\n}\n\n/* Sub Heading - Explore */\n.sub-heading-font {\n  color: #333;\n  font-family: \"Roboto Bold\", sans-serif;\n  /* font-size: 50%; */\n}\n\n/* Sub Heading - Arab American History */\n.sub-heading-font2 {\n  font-family: \"Roboto-Slab\", sans-serif;\n  color: #427e93;\n  font-weight: 200;\n}\n\n/* Search Div */\n.search-div {\n  display: flex;\n  justify-content: center;\n  text-align: center;\n  margin-top: 60px;\n}\n\n/* Search Input */\n.search-input {\n  text-indent: 10%;\n  font-size: 22px;\n  height: 68px;\n  width: 720px;\n  border-top: 0px;\n  border-right: 0px;\n  border-left: 0px;\n  border-bottom: 2px solid #cccccc;\n  border-radius: 36px;\n  font-family: \"Roboto\", sans-serif;\n}\n\n/* Or Image Div */\n.arabic-or-image-div {\n  height: 24px;\n  width: 22px;\n  font-family: \"Roboto Slab\", sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  /* font-size: 16px; */\n  /* line-height: 150%; */\n  text-align: center;\n  color: #fff;\n  margin-top: 20px;\n}\n\n.arabic-or-image-div svg {\n  width: 500px;\n  /* height: auto; */\n}\n\n@media (max-width: 550px) {\n  .arabic-or-image-div svg {\n    width: 90%;\n  }\n}\n\n/* Browse Collection Div */\n.arabic-browse-collection-div {\n  display: flex;\n  justify-content: center;\n  text-align: center;\n  font-family: \"Roboto\", sans-serif;\n  font-style: normal;\n  font-weight: 500;\n  font-size: 28px;\n  line-height: 100%;\n  margin-top: 25px;\n  margin-bottom: 20px;\n}\n\n/* Browse Text - Browse our collection */\n.arabic-browse-text-span {\n  color: #333;\n  font-family: \"Roboto Bold\", sans-serif;\n}\n\n/* Browse Text - By Selecting */\n.arabic-by-selecting-span {\n  color: #999;\n  margin-top: 5px;\n  display: inline-block;\n}\n\n/* Newspaper Button */\n.arabic-newspaper-button {\n  text-indent: 5%;\n  height: 48px;\n  width: 15rem;\n  padding: 5px;\n  padding-right: 1.8em;\n  background: #fff;\n  align-items: center;\n  border: 1px solid #cccccc;\n  font-family: \"Roboto\", sans-serif;\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 20px;\n  font-style: normal;\n  background-color: #fff;\n  text-align: right;\n}\n\n/* Smaller Search Icon */\n.arabic-smaller-search-icon {\n  color: #ff0000;\n  height: 14px;\n  float: left;\n  margin-left: 10px;\n  margin-top: 2px;\n  display: flex;\n  align-items: center;\n}\n\n/* Collections Div */\n.collections-div {\n  text-align: center;\n  border-left: 2px solid #cccccc;\n}\n\n/* Icon Style */\n.arabic-icon-style {\n  padding: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: end;\n}\n\n/* Info Style */\n.arabic-info-style {\n  padding: 8px;\n  margin: 0px;\n  display: flex;\n  align-items: center;\n}\n\n/* Span Style - 4382 */\n.arabic-span-style-4382 {\n  font-family: \"Roboto-Slab\", sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 40px;\n  color: #427e93;\n}\n\n/* Span Style - Below 4382 */\n.arabic-span-style-below-4382 {\n  font-family: \"Roboto\", sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 18px;\n  line-height: 150%;\n  color: #808080;\n}\n\n/* Search and Browse Div */\n.arabic-search-browse-div {\n  display: flex;\n  justify-content: center;\n  text-align: center;\n  font-family: \"Roboto\", sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 2rem;\n  line-height: 150%;\n  color: #666666;\n}\n\n@media (max-width: 600px) {\n  .search-browse-div {\n    font-size: 1.5rem;\n  }\n}\n\n/* Learn More Span */\n.arabic-learn-more-span {\n  font-family: \"Roboto\", sans-serif;\n  font-style: normal;\n  font-weight: 700;\n  font-size: 24px;\n  line-height: 167%;\n  color: #ff0000;\n}\n\n/* Drop Down Style */\n.drop-down-style {\n  height: 48px;\n  border: 1px solid #cccccc;\n  border-radius: 36px;\n  background-color: #ffffff;\n  font-family: \"Roboto\", sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 150%;\n  color: #808080;\n  padding-right: 10px;\n}\n\n.arabic-stats {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-right: solid #cccccc;\n  margin: 1%;\n}\n\n.arabic-periodicals-books {\n  display: flex;\n  justify-content: center;\n  justify-content: space-evenly;\n}\n\n@media (max-width: 700px) {\n  .heading {\n    font-size: 4.5rem;\n  }\n}\n\n@media (max-width: 380px) {\n  .heading {\n    font-size: 3.5rem;\n  }\n}\n\n@media (max-width: 600px) {\n  .arabic-periodicals-books {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .arabic-periodicals {\n    margin: 20px;\n  }\n}\n\n.arabic-main-container {\n  background-color: #dedede;\n}\n\n.arabic-heading {\n  font-family: \"Roboto Bold\", \"Roboto\", sans-serif;\n  font-size: 4.15rem;\n  line-height: 1;\n  margin-top: 0;\n}\n\n.arabic-heading p {\n  margin-bottom: 1rem;\n}\n\n.arabic-browse-text-span {\n  color: #666666;\n  font-family: \"Roboto Bold\", \"Roboto\", sans-serif;\n  font-size: 28px;\n}\n\n.arabic-by-selecting-span {\n  color: #999999;\n  font-family: \"Roboto Bold\", \"Roboto\", sans-serif;\n  font-size: 24px;\n}\n\n.arabic-periodicals-books {\n  gap: 32px;\n  justify-content: center;\n  margin: 26px auto 34px;\n  max-width: 1320px;\n  width: calc(100% - 56px);\n}\n\n.arabic-periodicals-books .browse-format-card {\n  align-items: flex-end;\n  min-height: 205px;\n  text-align: right;\n}\n\n.arabic-periodicals-books .browse-format-card__icon {\n  margin-left: 0;\n  margin-right: 0;\n}\n\n.arabic-periodicals-books .browse-format-card__title,\n.arabic-periodicals-books .browse-format-card__subtitle {\n  width: 100%;\n}\n\n.arabic-periodicals-books .browse-format-card__cta {\n  align-self: flex-end;\n  flex-direction: row;\n}\n\n.arabic-stats {\n  border-right: 0;\n  margin: 0;\n}\n\n.stats-panel[dir=\"rtl\"] .stats {\n  border-left: 0;\n  border-right: 1px solid #d9d9d9;\n}\n\n.stats-panel[dir=\"rtl\"] .stats:first-child {\n  border-right: 0;\n}\n\n.stats-panel[dir=\"rtl\"] .stats .icon-style {\n  padding: 0 0 0 22px;\n}\n\n.stats-panel[dir=\"rtl\"] .info-style {\n  text-align: right;\n}\n\n.arabic-span-style-4382 {\n  font-family: \"Roboto Bold\", \"Roboto\", sans-serif;\n}\n\n.arabic-span-style-below-4382 {\n  font-family: \"Roboto Bold\", \"Roboto\", sans-serif;\n}\n\n.arabic-search-browse-div {\n  font-family: \"Roboto Bold\", \"Roboto\", sans-serif;\n  font-weight: 500;\n  margin-left: auto;\n  margin-right: auto;\n  max-width: 1120px;\n  padding: 0;\n}\n\n.arabic-learn-more-span {\n  font-family: \"Roboto Bold\", \"Roboto\", sans-serif;\n  font-size: 21px;\n}\n\n@media (max-width: 700px) {\n  .arabic-heading {\n    font-size: 3.6rem;\n  }\n}\n\n@media (max-width: 600px) {\n  .arabic-periodicals-books {\n    gap: 18px;\n    margin-top: 24px;\n    padding: 0 18px;\n    width: 100%;\n  }\n}\n\n@media (max-width: 380px) {\n  .arabic-heading {\n    font-size: 2.9rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
